import { client } from "@application/config/apollo";

// File URLs expire 4–8 hours after the server issues them (CdnRoutable). Refetch
// the page's queries for fresh ones before the oldest can expire, and right away
// when a file image fails to load (e.g. stale data from a page visited earlier).
const REFRESH_AFTER_MS = 3 * 60 * 60 * 1000;
const MIN_GAP_MS = 60 * 1000;

let refreshedAt = Date.now();

const refresh = (minAgeMs: number) => {
  if (Date.now() - refreshedAt < minAgeMs) return;
  refreshedAt = Date.now();
  void client.refetchQueries({ include: "active" });
};

// A link that fails again after a refetch is broken (e.g. a deleted file), not
// expired, so it doesn't trigger another one.
const failedSrcs = new Set<string>();

const isFileImage = (target: EventTarget | null): target is HTMLImageElement =>
  target instanceof HTMLImageElement &&
  target.src.includes("/rails/active_storage/");

const onImageError = (target: EventTarget | null) => {
  if (!isFileImage(target) || failedSrcs.has(target.src)) return;
  failedSrcs.add(target.src);
  refresh(MIN_GAP_MS);
};

if (typeof document !== "undefined") {
  document.addEventListener(
    "error",
    (event) => onImageError(event.target),
    true,
  );
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") refresh(REFRESH_AFTER_MS);
  });
  setInterval(() => refresh(REFRESH_AFTER_MS), 10 * 60 * 1000);
}
